export const getCurrentHostName = () => {
  let hostname = window.location.href

  hostname = hostname.replace("http://", "")
  hostname = hostname.replace("https://", "")
  hostname = hostname.replace("www.", "")
  hostname = hostname.replace("beta.", "")
  hostname = hostname.replace("beta-", "")
  hostname = hostname.replace("local-", "")
  hostname = hostname.replace("local.", "")
  hostname = hostname.replace("hmg-", "")
  hostname = hostname.replace("hmg.", "")

  return hostname
}

export default getCurrentHostName
